import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import RequestSentDetailsDS from "../../DataServices/RequestSentDetailsDS";
import { insertLog } from "../Logs/InsertLog";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

const useRequestDetailLogic = () => {

    const [isPinned, setIsPinned] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { record: initialRecord } = location.state || {};

    const queryParams = new URLSearchParams(location.search);
    const requestIDFromURL = queryParams.get("requestID");
    const normalizeRecord = (raw) => {
        if (!raw) return {};
        const base = raw.requests || raw;
        return {
            ...base,
            id: base._id || base.id || raw._id || raw.id,
            filesCount: base.totalFilesCount ?? raw.totalFilesCount ?? 0,
            casesCount: base.totalCasesCount ?? raw.totalCasesCount ?? 0,
            filesData: raw.files || null,
            agencyPhoneNumber: raw.agencyPhoneNumber || base.agencyPhoneNumber
        };
    };
    const getAudioUrl = async (key) => {
        const idToken = localStorage.getItem("idToken");

        const s3 = new S3Client({
            region: process.env.REACT_APP_AWS_REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                logins: {
                    [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]: idToken,
                },
            }),
        });

        const command = new GetObjectCommand({
            Bucket: process.env.REACT_APP_CONNECT_BUCKET,
            Key: key,
        });

        const url = await getSignedUrl(s3, command, { expiresIn: 3600 });
        return url;
    };

    const [record, setRecord] = useState(normalizeRecord(initialRecord));
    const [isLoadingRecord, setIsLoadingRecord] = useState(false);
    const requestSentDS = new RequestSentDetailsDS();
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];
    const [showEventModal, setShowEventModal] = useState(false);
    const [eventData, setEventData] = useState({ startDateTime: "", endDateTime: "", message: "" });
    const [openSection, setOpenSection] = useState(["events"]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [textArea, setTextArea] = useState("");
    const [showChequeModal, setShowChequeModal] = useState(false);
    const [showViewChequeModal, setShowViewChequeModal] = useState(false);
    const [chequePdfUrl, setChequePdfUrl] = useState("");
    const [chequePaymentTo, setChequePaymentTo] = useState("");
    const [chequeAmount, setChequeAmount] = useState("");
    const [chequeMemo, setChequeMemo] = useState("");
    const [chequeAddress, setChequeAddress] = useState({ address: "", city: "", state: "", zip: "" });
    const [viewChequeRequestId, setViewChequeRequestId] = useState("");
    const [chequeData, setChequeData] = useState(null);
    const [eventErrors, setEventErrors] = useState({});
    const viewHighlightFileds = ["Sent", "Escalated", "Closed-Data Received", "Closed-No Data", "Payment Pending", "Payment Closed"];
    const [callHistory, setCallHistory] = useState([]);
    const [chequeErrors, setChequeErrors] = useState({});
    const [noteError, setNoteError] = useState("");

    const normalizeText = (value) => {
        return value.replace(/\s+/g, " ").trim();
    };
    useEffect(() => {
          // if (record?.requestID) return;
        if (!requestIDFromURL) return;

        const fetchRecord = async () => {
            setIsLoadingRecord(true);
            hud("Loading...");
            try {
                const response = await requestSentDS.WS_OutgoingRequest_Details_GET({
                    requestID: requestIDFromURL
                });
                const data = response.data;
                const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

                if (data.statusCode === 200 && body) {
                    console.log("fetchRecord", body);
                    const normalized = normalizeRecord({
                        ...body,
                        id: body._id,
                        filesCount: body.totalFilesCount ?? 0,
                        casesCount: body.totalCasesCount ?? 0,
                    });
                    setRecord(normalized);
                } else {
                    showAlert("Failed to load record.", [
                        { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                    ]);
                }
            } catch (err) {
                showAlert(err.message || "Error loading record.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
            } finally {
                stopHudRotation();
                setIsLoadingRecord(false);
            }
        };

        fetchRecord();
    }, [requestIDFromURL]);

    const normalizeReqKey = (type) => {
        if (!type) return "";
        type = type.toLowerCase().trim();
        if (type === "fax") return "fax";
        if (type === "email") return "emailReq";
        if (type === "snail mail") return "snail";
        if (type === "drop off") return "dropoff";
        if (type.includes("agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocx";
        return "";
    };


    const shouldShowCallAction = (record) => {
        if (!record) return false;

        if (record.filesCount > 0) {
            return false;
        }
        if (record.url) return false;

        if (!record.TriggerEvents || record.TriggerEvents.length === 0) return true;


        const waitDays = Number(record.TriggerEvents[0]?.waitDays ?? 0);

        if (!record.triggeredOnDate) return false;

        const [year, month, day] = record.triggeredOnDate
            .split("-")
            .map(Number);

        const triggeredHour = Number(record.triggeredAtHour ?? 0);

        // Trigger time in ET
        const triggerET = new Date(
            `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}T${String(triggeredHour).padStart(2, "0")}:00:00`
        );

        const threshold = new Date(triggerET);
        threshold.setDate(threshold.getDate() + waitDays);

        const nowET = new Date(
            new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
        );

        return nowET >= threshold;
    };


    const normalizeResKey = (type) => {
        if (!type) return "";
        type = type.toLowerCase().trim();
        if (type.includes("fax")) return "fax";
        if (type.includes("email")) return "email";
        if (type.includes("pick")) return "pickup";
        if (type.includes("snail")) return "snailmail";
        if (type.includes("agency website")) return "agenweb";
        if (type.includes("crash")) return "crashdocs";
        return "";
    };

    const reqMethodKey = normalizeReqKey(record.requestMethod?.requestType);
    const resMethodKey = normalizeResKey(record.responseMethod?.responseType);
    const freqType = record.frequency?.frequencyType || "";

    const formatToLocalDateTime = (timestamp) => {
        if (!timestamp) return "";

        const normalized = typeof timestamp === "string"
            ? timestamp.trim().replace(" ", "T")
            : timestamp;

        const date = new Date(normalized);
        if (isNaN(date.getTime())) return "";

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    };

    const numberToWords = (amount) => {
        const integer = Math.floor(amount);
        const decimal = Math.round((amount - integer) * 100);
        return `${integer} DOLLARS${decimal > 0 ? ` AND ${decimal} CENTS` : ""}`;
    };

    const toggleSection = (section) => {
        setOpenSection((prev) => {
            if (prev.includes(section)) {
                return prev.filter((item) => item !== section);
            } else {
                return [...prev, section];
            }
        });
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => showToast({ message: "Request Id copied!" }))
            .catch(() => showToast({ message: "Failed to copy!" }));
    };

    const handlePayableToChange = (e) => {
        const value = e.target.value.replace(/^\s+/, "");
        setChequePaymentTo(value);
        if (chequeErrors.payableTo) setChequeErrors(p => ({ ...p, payableTo: "" }));
    };

    const handleAmountChange = (e) => {
        const value = e.target.value.replace(/^\s+/, "");
        if (/^\d*\.?\d*$/.test(value)) {
            setChequeAmount(value);
            if (chequeErrors.amount) setChequeErrors(p => ({ ...p, amount: "" }));
        }
    };

    const refreshRecord = async () => {
        try {
            const response = await requestSentDS.WS_OutgoingRequest_Details_GET({ requestID: record.requestID });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;

            const actualRecord = body.requests || body;
            if (data.statusCode === 200 && actualRecord) {

                const updated = {
                    ...actualRecord,
                    id: actualRecord._id || actualRecord.id,
                    filesCount: actualRecord.totalFilesCount ?? body.totalFilesCount ?? 0,
                    casesCount: actualRecord.totalCasesCount ?? body.totalCasesCount ?? 0,
                    filesData: body.files || null,  // new: pull files object from top level
                    agencyPhoneNumber: actualRecord.agencyPhoneNumber || body.agencyPhoneNumber
                };
                setRecord(updated);
                return updated;
            }
            else {
                showAlert(body?.message || "failed to refresh record for request.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to refresh record for request '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'GET',
                    'WS_OutgoingRequest_Details_GET',
                    'FAILED',
                    'failed to refresh record for request'
                );
            }
        } catch (err) {
            showAlert("failed to refresh record for request", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
            insertLog(
                `${userName} failed to refresh record for request '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'GET',
                'WS_OutgoingRequest_Details_GET',
                'FAILED',
                err.message
            );
            return null;
        }
    };

    const handleTextSubmit = async (e) => {
        e.preventDefault();
        if (!normalizeText(textArea)) {
            setNoteError("Note is required");
            return;
        }
        setNoteError("");
        hud("Updating Notes.");
        try {
            const req = { _id: record.id, text: normalizeText(textArea), updated_by_email_id: useremail, isPinned: isPinned };
            const response = await requestSentDS.WS_OutgoingRequest_Notes_ByID_UPDATE(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body.message === "Note added successfully") {
                insertLog(
                    `${userName} added a note for '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                await refreshRecord();
            } else {
                showAlert(body?.message || "Unable to add note.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to add a note for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'FAILED',
                    'Unable to add note'
                );
            }
        } catch (err) {
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);

            insertLog(
                `${userName} failed to add a note for '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Notes_ByID_UPDATE',
                'FAILED',
                err.message
            );
        } finally { stopHudRotation(); setShowAddModal(false); setNoteError(""); }
    };

    const handlePinNote = async (noteIndex, currentPinState) => {
        try {
            hud("Updating...");
            const req = {
                _id: record.id,
                noteIndex: noteIndex,
                isPinned: !currentPinState,
                updated_by_email_id: useremail
            };
            const response = await requestSentDS.WS_OutgoingRequest_Notes_ByID_UPDATE(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200) {
                insertLog(
                    `${userName} ${currentPinState ? "unpinned" : "pinned"} a note for '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                await refreshRecord();
            } else {
                showAlert(body?.message || "Failed to update pin.", [
                    { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                insertLog(
                    `${userName} failed to ${currentPinState ? "unpin" : "pin"} a note for '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Notes_ByID_UPDATE',
                    'FAILED',
                    `failed to ${currentPinState ? "unpin" : "pin"} a note for '${record.requestID}`
                );
            }
        } catch (err) {
            showAlert(err.message || "Failed.", [
                { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
            insertLog(
                `${userName} failed to ${currentPinState ? "unpin" : "pin"} a note for '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Notes_ByID_UPDATE',
                'FAILED',
                err.message
            );

        } finally {
            stopHudRotation();
        }
    };

    const fetchAgencyAddress = async (agencyID) => {
        try {
            if (!agencyID) { showToast({ message: "Agency ID missing" }); return; }
            hud("Loading agency details...");
            const response = await requestSentDS.WS_Agency_Address_ById_GET({ agencyID });
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body?.record) {
                const rec = body.record;
                setChequePaymentTo(rec.agencyDisplayName || "");
                setChequeAddress({
                    address: rec.agencyAddress?.address || "",
                    city: rec.agencyAddress?.city || "",
                    state: rec.agencyAddress?.state || "",
                    zip: rec.agencyAddress?.zip || ""
                });
            } else {
                showToast({ message: "Agency record not found" });
                insertLog(
                    `${userName} failed to fetch agency address for agency '${agencyID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    agencyID || '',
                    'GET',
                    'WS_Agency_Address_ById_GET',
                    'FAILED',
                    'failed to fetch agency address'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch agency address for agency '${agencyID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                agencyID || '',
                'GET',
                'WS_Agency_Address_ById_GET',
                'FAILED',
                err.message
            );
            console.error("Error fetching agency address:", err);
            showToast({ message: "Error fetching agency details" });
        } finally { stopHudRotation(); }
    };

    const handleOpenChequeModal = () => {
        setChequeData(null);
        setChequePaymentTo("");
        setChequeAmount("");
        setChequeMemo("");
        setChequeAddress({ address: "", city: "", state: "", zip: "" });
        setChequeErrors({});
        fetchAgencyAddress(record.agencyID);
        setShowChequeModal(true);
    };

    const handleGenerateCheque = async (e) => {
        e.preventDefault();
        const errs = {};
        if (!normalizeText(chequePaymentTo)) errs.payableTo = "Payable To is required";
        if (!chequeAmount.trim()) errs.amount = "Amount is required";
        if (!normalizeText(chequeAddress.address)) errs.address = "Address is required";
        if (!normalizeText(chequeAddress.city)) errs.city = "City is required";
        if (!normalizeText(chequeAddress.state)) errs.state = "State is required";
        if (!normalizeText(chequeAddress.zip)) errs.zip = "Zip is required";
        setChequeErrors(errs);
        if (Object.keys(errs).length > 0) return;
        hud("Generating Cheque...");
        try {
            const req = {
                requestID: record.id,
                datasetID: record.datasetID,
                datasetName: record.datasetName,
                cheque: {
                    payableTo: normalizeText(chequePaymentTo),
                    amount: parseFloat(chequeAmount),
                    amountInWords: numberToWords(parseFloat(chequeAmount)),
                    address: {
                        address: normalizeText(chequeAddress.address),
                        city: normalizeText(chequeAddress.city),
                        state: normalizeText(chequeAddress.state),
                        zip: normalizeText(chequeAddress.zip),
                    },
                    memo: normalizeText(chequeMemo),
                    created_by_email_id: useremail
                }
            };
            const response = await requestSentDS.WS_OutgoingRequest_Cheque_Generate(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200) {
                showToast({ message: "Cheque generated and uploaded successfully!" });
                setShowChequeModal(false);
                setChequePaymentTo("");
                setChequeAmount("");
                setChequeMemo("");
                setChequeAddress({ address: "", city: "", state: "", zip: "" });
                setChequeErrors({});
                await refreshRecord();
                insertLog(
                    `${userName} generated a cheque for request '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'INSERT',
                    'WS_OutgoingRequest_Cheque_Generate',
                    'SUCCESS',
                    ''
                );
            } else {
                showAlert(body?.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);

                insertLog(
                    `${userName} failed to generate cheque for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.requestID || '',
                    'INSERT',
                    'WS_OutgoingRequest_Cheque_Generate',
                    'FAILED',
                    'Unable to generate cheque'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to generate cheque for request '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'INSERT',
                'WS_OutgoingRequest_Cheque_Generate',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally { stopHudRotation(); }
    };

    const handleViewCheque = async (cheque) => {
        if (!cheque?.s3Key) return;
        hud("Loading Cheque...");
        try {

            const req = {
                s3Key: cheque.s3Key,
                datasetID: record.datasetID,
                datasetName: record.datasetName
            }
            const response = await requestSentDS.WS_OutgoingRequest_Cheque_PresignedUrl_GET(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200 && body.presignedUrl) {
                setChequePdfUrl(body.presignedUrl);
                setViewChequeRequestId(record.requestID);
                setShowViewChequeModal(true);
            }
            else {
                insertLog(
                    `${userName} failed to view cheque for request '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'GET',
                    'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
                    'FAILED',
                    'failed to view cheque'
                );
                showAlert(body.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
            }
        } catch (err) {
            insertLog(
                `${userName} failed to view cheque for request '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'GET',
                'WS_OutgoingRequest_Cheque_PresignedUrl_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally { stopHudRotation(); }
    };


    //  const handleViewPDF = async (id) => {
    //     try {
    //         hud("Loading PDF...");
    //         const response = await requestSentDS.WS_SentPdfData_ByID_GET({ _id: id });
    //         const data = response.data;
    //         const base64String = data.body;
    //         if (data.statusCode === 200 && base64String) {
    //             const byteCharacters = atob(base64String);
    //             const byteNumbers = new Array(byteCharacters.length);
    //             for (let i = 0; i < byteCharacters.length; i++) {
    //                 byteNumbers[i] = byteCharacters.charCodeAt(i);
    //             }
    //             const byteArray = new Uint8Array(byteNumbers);
    //             const blob = new Blob([byteArray], { type: "application/pdf" });
    //             const blobUrl = URL.createObjectURL(blob);
    //             window.open(blobUrl, "_blank");
    //         }
    //         else {
    //             insertLog(
    //                 `${userName} failed to view PDF for request '${record.requestID}'`,
    //                 0,
    //                 useremail,
    //                 hud,
    //                 stopHudRotation,
    //                 showAlert,
    //                 record.id || '',
    //                 'GET',
    //                 'WS_SentPdfData_ByID_GET',
    //                 'FAILED',
    //                 'failed to view PDF'
    //             );
    //             showAlert(base64String.message || "Error loading PDF.", [
    //                 { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //             ]);
    //         }
    //     } catch (err) {
    //         insertLog(
    //             `${userName} failed to view PDF for request '${record.requestID}'`,
    //             0,
    //             useremail,
    //             hud,
    //             stopHudRotation,
    //             showAlert,
    //             record.id || '',
    //             'GET',
    //             'WS_SentPdfData_ByID_GET',
    //             'FAILED',
    //             err.message
    //         );
    //         showAlert(err.message || "Error loading PDF.", [
    //             { label: "OK", onClick: () => { }, color: "var(--buttonColor)" }
    //         ]);
    //     } finally {
    //         stopHudRotation();
    //     }
    // };

    const normalizeBucketNamePart = (value) => (
        String(value)
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "-")
            .replace(/-+/g, "-")
            .replace(/^-+|-+$/g, "")
    );

    const handleViewPDF = async (s3Key) => {
        if (!s3Key) {
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
            return;
        }
        try {
            hud("Generating preview...");

            const idToken = localStorage.getItem("idToken");

            const bucketName = `${normalizeBucketNamePart(record.datasetID)}-${normalizeBucketNamePart(record.datasetName)}-files-${process.env.REACT_APP_ALIAS}`;


            const s3 = new S3Client({
                region: process.env.REACT_APP_AWS_REGION,
                credentials: fromCognitoIdentityPool({
                    clientConfig: { region: process.env.REACT_APP_AWS_REGION },
                    identityPoolId: process.env.REACT_APP_CONNECT_IDENTITY_POOL_ID,
                    logins: {
                        [`cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USERPOOLID}`]:
                            idToken,
                    },
                }),
            });

            const { getSignedUrl } = await import("@aws-sdk/s3-request-presigner");
            const { GetObjectCommand } = await import("@aws-sdk/client-s3");

            const command = new GetObjectCommand({
                Bucket: bucketName,
                Key: s3Key,
                ResponseContentDisposition: "inline",
                ResponseContentType: "application/pdf",
            });

            const signedUrl = await getSignedUrl(s3, command, { expiresIn: 300 }); // 5 min
            window.open(signedUrl, "_blank");

        } catch (err) {
            console.error("Presigned URL error:", err);
            showAlert("Failed to generate preview. Please try again.", [
                { label: "OK", color: "var(--buttonColor)", onClick: () => { } }
            ]);
        } finally {
            stopHudRotation();
        }
    };


    const handleViewFilePDF = async (s3Key) => {
        showToast({ message: "Api not implemented" });
    };
    const handleEventSubmit = async (e) => {
        e.preventDefault();
        const errs = {};
        if (!eventData.startDateTime) errs.startDateTime = "Start Date Time is required";
        if (!eventData.endDateTime) errs.endDateTime = "End Date Time is required";
        setEventErrors(errs);
        if (Object.keys(errs).length > 0) return;
        hud("Loading...");
        try {
            const req = {
                _id: record.id,
                startDateTime: eventData.startDateTime.replace("T", " ") + ":00",
                endDateTime: eventData.endDateTime.replace("T", " ") + ":00",
                message: normalizeText(eventData.message),
                updated_by_email_id: useremail
            };
            const response = await requestSentDS.WS_OutgoingRequest_Event_ByID_UPDATE(req);
            const data = response.data;
            const body = typeof data.body === "string" ? JSON.parse(data.body) : data.body;
            if (data.statusCode === 200) {
                insertLog(
                    `${userName} added an event for '${record.requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Event_ByID_UPDATE',
                    'SUCCESS',
                    ''
                );
                showToast({ message: "Event added successfully" });
                await refreshRecord();
            } else {
                showAlert(body?.message || "Unable to add event.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
                insertLog(
                    `${userName} failed to add an event for VIN '${record.requestID}' and agency '${record.agencyName}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    record.id || '',
                    'UPDATE',
                    'WS_OutgoingRequest_Event_ByID_UPDATE',
                    'FAILED',
                    'Unable to add event'
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to add an event for '${record.requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                record.id || '',
                'UPDATE',
                'WS_OutgoingRequest_Event_ByID_UPDATE',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Failed.", [{ label: "OK", onClick: () => { }, color: "var(--buttonColor)" }]);
        } finally {
            stopHudRotation();
            setShowEventModal(false);
            setEventErrors({});
        }
    };

    const fetchCallHistory = async (requestID) => {
        try {
            hud("Please Wait..");
            const req = { vin_id: requestID };
            const response = await requestSentDS.AC_Call_Info_By_VIN_GET(req);
            const data = response.data;
            const body = Array.isArray(data.body)
                ? data.body
                : typeof data.body === "string"
                    ? JSON.parse(data.body)
                    : data.body;

            if (data.statusCode === 200 && Array.isArray(body)) {
                setCallHistory(body);

                console.log("callDATA", setCallHistory(body));
            } else {
                showAlert(body?.message || "Failed to load call history.", [
                    { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
                ]);
                insertLog(
                    `${userName} failed to fetch call history for '${requestID}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    requestID || '',
                    'GET',
                    'AC_Call_Info_By_VIN_GET',
                    'FAILED',
                    `failed to fetch call history for '${requestID}'`
                );
            }
        } catch (err) {
            insertLog(
                `${userName} failed to fetch call history for '${requestID}'`,
                0,
                useremail,
                hud,
                stopHudRotation,
                showAlert,
                requestID || '',
                'GET',
                'AC_Call_Info_By_VIN_GET',
                'FAILED',
                err.message
            );
            showAlert(err.message || "Something went wrong while fetching call history.", [
                { label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }
            ]);
        } finally {
            stopHudRotation();
        }
    };

    const getNowDateTimeLocal = () => {
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        const hh = String(now.getHours()).padStart(2, "0");
        const min = String(now.getMinutes()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };

    return {
        navigate,
        record,
        isLoadingRecord,
        openSection,
        toggleSection,
        showAddModal,
        setShowAddModal,
        textArea,
        setTextArea,
        handleTextSubmit,
        showEventModal,
        setShowEventModal,
        eventData,
        setEventData,
        showChequeModal,
        setShowChequeModal,
        showViewChequeModal,
        setShowViewChequeModal,
        chequePdfUrl,
        setChequePdfUrl,
        chequePaymentTo,
        setChequePaymentTo,
        chequeAmount,
        chequeAddress,
        setChequeAddress,
        chequeMemo,
        setChequeMemo,
        chequeData,
        viewChequeRequestId,
        handleOpenChequeModal,
        handleGenerateCheque,
        handleViewCheque,
        handleAmountChange,
        handleCopy,
        reqMethodKey,
        resMethodKey,
        freqType,
        viewHighlightFileds,
        formatToLocalDateTime,
        handleViewPDF,
        handleViewFilePDF,
        handleEventSubmit,
        eventErrors,
        setEventErrors,
        shouldShowCallAction,
        callHistory,
        setCallHistory,
        fetchCallHistory,
        getAudioUrl,
        setRecord,
        isPinned,
        setIsPinned,
        handlePinNote,
        chequeErrors,
        setChequeErrors,
        noteError,
        setNoteError,
        handlePayableToChange,
        getNowDateTimeLocal,
    };
};

export default useRequestDetailLogic;